var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1552 14.57C17.6852 14.27 17.0752 14.42 16.7752 14.88C15.8752 16.27 14.4752 17.29 12.8152 17.68C10.9652 18.11 9.03516 18.12 7.18516 17.68C4.79516 17.12 2.88516 15.21 2.32516 12.83C1.89516 10.98 1.88516 9.05 2.32516 7.19C2.88516 4.8 4.79516 2.89 7.17516 2.33C8.10516 2.11 9.04516 2 9.99516 2C10.5452 2 10.9952 1.55 10.9952 1C10.9952 0.45 10.5452 0 9.99516 0C8.89516 0 7.79516 0.13 6.71516 0.38C3.58516 1.12 1.10516 3.61 0.375156 6.74C-0.114844 8.85 -0.124844 11.05 0.345156 13.16C1.05516 16.32 3.53516 18.88 6.69516 19.62C8.85516 20.13 11.1152 20.13 13.2752 19.62C15.4552 19.11 17.2852 17.77 18.4552 15.95C18.7552 15.48 18.6252 14.86 18.1552 14.56V14.57Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99512 8.51001H18.9951",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9951 6.01001L19.9255 8.10314C20.2047 8.30255 20.2047 8.71747 19.9255 8.91688L16.9951 11.01",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.33c6daacafbb8369111a59e900819873.svg";
export { ForwardRef as ReactComponent };